import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { HexLinkModule } from "@hex/angular/link";
import { DownloadLinkComponent } from "./download-link.component";

@NgModule({
    imports: [
        CommonModule,
        HexLinkModule,
    ],
    exports: [
        ...[
            DownloadLinkComponent,
        ],
    ],
    declarations: [
        DownloadLinkComponent,
    ],
    providers: [],
})
export class DownloadLinkModule {
}
